import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ImportModal from "../../components/Modals/ImportModel";
import ExportModal from "../../components/Modals/ExportsModel/main";
import GenerateTicketsModal from "../../components/Modals/GenerateTicketsModal";
import AddAMCModal from "../../components/Modals/AddAmcModel";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { toast } from "react-toastify";
import axios from "axios";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import Loader from "../../components/Loader";
import { Accordion, Form } from "react-bootstrap";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
} from "react-icons/fa";
import AMCViewModal from "../../components/Modals/AMCViewModal";
import { useCommonContext } from "../../utils/context";

import AmcViewDetailsModel from "../../components/Modals/HisstoryModals/AmcViewModel";
import CommonButton from "../../components/CommonButton";
import StatusBadge from "../../components/StatusBadge";
import Pagination from "../../components/Pagination";
import NoData from "../../components/NoData";

const Amc = () => {
  const [showAmcModal, setShowAmcModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [amcData, setAmcData] = useState([]);
  const [allAmc, setAllAmc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchAmcText, setSearchAmcText] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [isCalendarView, setIsCalendarView] = useState(false);
  const [selectedAmc, setSelectedAmc] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = amcData.slice(itemOffset, endOffset);
  const userPermissions = localStorage.getItem("user_permissions");

  const localizer = momentLocalizer(moment);

  const [showAmcViewModal, setShowAmcViewModal] = useState(false);

  const fetchAllAmc = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/amcs/amc_count/`, {
        headers: HEADERS,
      });
      if (response.data && response.data) {
        setAllAmc(response.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchAmcData = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/api/amcs/`;

      const response = await axios.get(url, {
        params: {
          page: page,
          page_size: itemsPerPage,
          search: searchAmcText,
          status: statusFilter,
        },
        headers: HEADERS,
      });

      if (response && response.data) {
        setAmcData(response.data.results || []);
        setCurrentPage(page);
        setTotalPages(response.data.total_pages);
        setLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchAmcData(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllAmc();
  }, [searchAmcText, statusFilter, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchAmcData(currentPage);
  }, [currentPage, itemsPerPage, searchAmcText, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchAmcText, statusFilter]);

  const handleEditAmc = (amc) => {
    setSelectedAmc(amc);
    setShowAmcModal(true);
  };

  const handleViewAmc = (amc) => {
    setSelectedAmc(amc);
    setShowViewModal(true);
  };

  const handleDeleteAmc = async (amcId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/api/amcs/${amcId}`, {
        headers: {
          ...HEADERS,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        toast.success(response.data.message);
        fetchAmcData(currentPage);
      }
    } catch (error) {
      console.error("Error deleting AMC:", error);
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);

        toast.error("Error Please Try again.");
      }
    }
  };

  const toggleView = () => {
    setIsCalendarView(!isCalendarView);
  };

  const handleViewAmcDetails = (amc) => {
    setSelectedAmc(amc);
    setShowAmcViewModal(true);
  };

  const handleAdd = () => {
    setSelectedAmc(null);
    setShowAmcModal(true);
  };

  const calendarEvents = amcData.map((amc) => ({
    id: amc.id,
    title: amc.amcName,
    start: new Date(amc.activationDate),
    end: new Date(amc.activationDate),
  }));

  const getAmcCountByStatus = (status) => {
    return allAmc[status] || 0;
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const AMC_COLORS = {
    expired: "#fdeaea",  
    renewal: "#fff8e1", 
    upcoming: "#e8f5e9",

    total: "#e3f2fd", 
    completed: "#e0f7fa", 
  };

  const STATUS_BORDERS = {
    expired: "#dc3545", 
    renewal: "#e0a800", 
    upcoming: "#218838", 

    total: "#0056b3", 
    completed: "#138496", 
  };

  const STATUS_CHOICES = [
    { label: "Total AMC", value: "total" },
    { label: "Upcoming", value: "upcoming" },
    { label: "Renewal", value: "renewal" },
    { label: "Completed", value: "completed" },
    { label: "Expired", value: "expired" },
  ];
  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex  container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">AMC Management</h4>

        <div className="d-none d-md-flex align-items-center gap-2">
          <CommonButton className="uniform-button" onClick={toggleView}>
            {isCalendarView ? "AMC List" : "AMC Calendar"}
          </CommonButton>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
        <div className="d-none d-md-flex align-items-center">
          <div className="me-2">
            <Form.Control
              type="text"
              value={searchAmcText}
              className="uniform-input search-text"
              placeholder="Search Here..."
              onChange={(e) => setSearchAmcText(e.target.value)}
            />
          </div>
          <div className="me-2">
            <Form.Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              disabled={currentItems.length === 0 && !statusFilter}
              className="uniform-input"
            >
              <option value="">All Status</option>
              <option value="Completed">Completed</option>
              <option value="Upcoming">Upcoming</option>
              <option value="Renewal">Renewal</option>
              <option value="Expired">Expired</option>
            </Form.Select>
          </div>
          {userPermissions.includes("amc_add_amc") && (
            <CommonButton className="uniform-button me-2" onClick={handleAdd}>
              <FaPlus style={{ marginRight: "6px" }} /> Add
            </CommonButton>
          )}
          {userPermissions.includes("amc_can_import_amc") && (
            <CommonButton
              className="uniform-button me-2"
              onClick={() => setShowImportModal(true)}
            >
              <FaFileImport style={{ marginRight: "6px" }} /> Import
            </CommonButton>
          )}
          {userPermissions.includes("amc_can_export_amc") && (
            <CommonButton
              className="uniform-button me-2"
              onClick={() => setShowExportModal(true)}
              disabled={currentItems.length === 0}
            >
              <FaFileExport style={{ marginRight: "6px" }} /> Export
            </CommonButton>
          )}
        </div>

        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body>
                <div className="mb-2">
                  <Form.Control
                    type="text"
                    value={searchAmcText}
                    className="uniform-input search-text"
                    placeholder="Search Here..."
                    onChange={(e) => setSearchAmcText(e.target.value)}
                  />
                </div>
                <div className="mb-2">
                  <Form.Select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    disabled={currentItems.length === 0 && !statusFilter}
                    className="uniform-input"
                  >
                    <option value="">All Status</option>
                    <option value="Completed">Completed</option>
                    <option value="Upcoming">Upcoming</option>
                    <option value="Renewal">Renewal</option>
                    <option value="Expired">Expired</option>
                  </Form.Select>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                  }}
                >
                  {userPermissions.includes("amc_add_amc") && (
                    <CommonButton
                      style={{
                        flex: "1 1 calc(33.333% - 8px)",
                        minWidth: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="uniform-button mb-2"
                      onClick={handleAdd}
                    >
                      <FaPlus style={{ marginRight: "6px" }} /> Add
                    </CommonButton>
                  )}

                  {userPermissions.includes("amc_can_import_amc") && (
                    <CommonButton
                      style={{
                        flex: "1 1 calc(33.333% - 8px)",
                        minWidth: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="uniform-button mb-2"
                      onClick={() => setShowImportModal(true)}
                    >
                      <FaFileImport style={{ marginRight: "6px" }} /> Import
                    </CommonButton>
                  )}

                  {userPermissions.includes("amc_can_export_amc") && (
                    <CommonButton
                      style={{
                        flex: "1 1 calc(33.333% - 8px)",
                        minWidth: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="uniform-button mb-2"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                    >
                      <FaFileExport style={{ marginRight: "6px" }} /> Export
                    </CommonButton>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      {!isCalendarView ? (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "15px",
              justifyContent: "center",
              padding: "10px",
            }}
          >
            {STATUS_CHOICES.map((item, index) => {
              const bgColor = AMC_COLORS[item.value] || "#ccc";
              const textColor = STATUS_BORDERS[item.value] || "#333";
              return (
                <div
                  key={index}
                  style={{
                    flex: "1 1 220px",
                    minWidth: "260px",
                    maxWidth: "280px",
                    backgroundColor: bgColor,
                    textAlign: "center",
                    borderRadius: "10px",
                    padding: "15px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                    transition: "transform 0.2s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <h6
                    style={{
                      color: textColor,
                      textTransform: "uppercase",
                      marginBottom: "8px",
                      fontSize: "14px",
                    }}
                  >
                    {item.label}
                  </h6>
                  <h2
                    style={{
                      color: textColor,
                      fontSize: "1.5rem",
                      fontWeight: "bold",

                      display: "inline-block",
                    }}
                  >
                    {getAmcCountByStatus(item.value)}
                  </h2>
                </div>
              );
            })}
          </div>

          <div
            className={`table-responsive ${
              currentItems.length === 0 ? "" : "tabell"
            } `}
            style={{ height: "60vh" }}
          >
            {loading ? (
              <Loader />
            ) : currentItems.length > 0 ? (
              <table className="table tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ width: "350px" }}>AMC ID/Name</th>
                    <th style={{ width: "200px" }}>Activation Date/Time</th>
                    <th style={{ width: "200px" }}>Customer Name</th>
                    <th style={{ width: "150px" }}>Services</th>
                    <th style={{ width: "200px" }}>Product Name</th>
                    <th style={{ width: "200px" }}>Product Brand</th>
                    <th style={{ width: "200px" }}>Serial Model No.</th>
                    <th style={{ width: "150px" }}>Service Amount</th>
                    <th style={{ width: "200px" }}>Service Occurrence</th>
                    <th style={{ width: "200px" }}>Received Amount</th>
                    {/* <th style={{ width: "150px" }}>Reminder</th> */}
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "250px" }}>Note</th>
                    <th style={{ width: "150px" }}></th>
                    <th style={{ width: "150px" }}></th>
                    <th style={{ width: "150px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((amc, index) => (
                    <tr
                      key={amc.id}
                      className="tbody"
                      onClick={() => handleViewAmcDetails(amc)}
                    >
                      <td>
                        <div className="d-flex align-items-center  ">
                          <span className="badge bg-primary text-white me-2">
                            {amc.id}
                          </span>
                          <div title={amc.amcName || "—"} className="tdsubject">
                            {amc.amcName}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            amc.activationDate
                              ? moment(amc.activationDate).format(
                                  "YYYY-MM-DD",
                                ) +
                                (amc.activationTime
                                  ? ` ${amc.activationTime}`
                                  : "")
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {amc.activationDate || amc.activationTime ? (
                            <>
                              {amc.activationDate
                                ? moment(amc.activationDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : ""}
                              {amc.activationTime && (
                                <>
                                  <br />
                                  <span className="badge bg-primary text-white">
                                    {amc.activationTime}
                                  </span>
                                </>
                              )}
                            </>
                          ) : (
                            "—"
                          )}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.customer?.customer_name || "—"}
                          className="tdsubject"
                        >
                          {amc.customer?.customer_name || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            amc.serviceCompleted && amc.no_of_service
                              ? `${amc.serviceCompleted} / ${amc.no_of_service}`
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {amc.serviceCompleted && amc.no_of_service
                            ? `${amc.serviceCompleted} / ${amc.no_of_service}`
                            : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.brand?.name || "—"}
                          className="tdsubject"
                        >
                          {amc.brand?.name || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.productBrand || "—"}
                          className="tdsubject"
                        >
                          {amc.productBrand || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.serialModelNo || "—"}
                          className="tdsubject"
                        >
                          {amc.serialModelNo || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.serviceAmount || "—"}
                          className="tdsubject"
                        >
                          {amc.serviceAmount || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.select_service_occurence || "—"}
                          className="tdsubject"
                        >
                          {amc.select_service_occurence || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={amc.receivedAmount || "—"}
                          className="tdsubject"
                        >
                          {amc.receivedAmount || "—"}
                        </div>
                      </td>
                      {/* <td>
                        <div title={amc.remainder || "—"} className="tdsubject">
                          {amc.remainder || "—"}
                        </div>
                      </td> */}
                      <td>
                        <StatusBadge status={amc.status} />
                      </td>

                      <td>
                        <div title={amc.note || "—"} className="tdsubject">
                          {amc.note || "—"}
                        </div>
                      </td>

                      <td>
                        <div className="action-icons">
                          {userPermissions.includes("amc_change_amc") && (
                            <FaEdit
                              className="me-3 cursor-pointer text-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditAmc(amc);
                              }}
                            />
                          )}
                          {userPermissions.includes("amc_delete_amc") && (
                            <FaTrashAlt
                              className="cursor-pointer"
                              style={{ color: "red" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteAmc(amc.id);
                              }}
                            />
                          )}
                        </div>
                      </td>

                      <td>
                        <span
                          className="text-primary"
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewAmc(amc);
                          }}
                        >
                          View Details
                        </span>
                      </td>
                      <td>
                        <span
                          className="text-primary"
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowTicketModal(true);
                          }}
                        >
                          Add Ticket
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </div>

          {currentItems.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              itemsPerPage={itemsPerPage}
              handlePageClick={handlePageClick}
              handleItemsPerPageChange={handleItemsPerPageChange}
            />
          )}
        </>
      ) : (
        <div className="mt-3">
          {loading ? (
            <Loader />
          ) : (
            <Calendar
              localizer={localizer}
              events={calendarEvents}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 500 }}
            />
          )}
        </div>
      )}

      <AddAMCModal
        show={showAmcModal}
        handleClose={() => {
          setSelectedAmc(null);
          setShowAmcModal(false);
        }}
        amcData={selectedAmc}
        fetchAmcData={() => fetchAmcData(currentPage)}
      />
      <ImportModal
        show={showImportModal}
        handleClose={() => setShowImportModal(false)}
        type="amcs"
        onSuccess={() => fetchAmcData(currentPage)}
      />
      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="amcs"
      />
      <GenerateTicketsModal
        show={showTicketModal}
        handleClose={() => setShowTicketModal(false)}
      />

      <AMCViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        amcData={selectedAmc}
      />

      <AmcViewDetailsModel
        show={showAmcViewModal}
        handleClose={() => setShowAmcViewModal(false)}
        amcId={selectedAmc?.id}
        amc={selectedAmc}
      />
    </div>
  );
};
export default Amc;
